module.exports = __webpack_public_path__ + "img/pic_empty_404txt@2x.8a2ecda1.png";